import React, { memo } from 'react';
import { overquotaAfterClear } from 'reactApp/appHelpers/featuresHelpers/features/overquotaAfterClear';
import { overquotaImgAbTest } from 'reactApp/appHelpers/featuresHelpers/features/overquotaImgAbTest';
import { overquotaNewCleared } from 'reactApp/appHelpers/featuresHelpers/features/overquotaNewCleared';
import { overquotaPayRestore } from 'reactApp/appHelpers/featuresHelpers/features/overquotaPayRestore';
import type { ModeType } from 'reactApp/ui/OverquotaPopup/newSplash/OverquotaSplash.types';

export const Title: React.FC<{ mode?: ModeType; isMobile?: boolean }> = memo(({ mode, isMobile }) => {
    if (mode === 'cleared') {
        return overquotaNewCleared ? <>Файлы в Облаке удалены </> : <>Ваши файлы в Облаке были удалены</>;
    }

    if (mode === 'after_clear' && overquotaAfterClear && overquotaPayRestore) {
        return <>Ваше пространство переполнено</>;
    }

    if (mode === 'full_blocked') {
        return (
            <>
                Доступ к файлам заблокирован,
                <br />
                но его можно вернуть
            </>
        );
    }

    if (mode === 'after_clear' && overquotaImgAbTest && !isMobile) {
        return (
            <>
                Доступа к файлам пока нет,
                <br />
                но его можно вернуть
            </>
        );
    }

    return (
        <>
            Доступ к файлам ограничен,
            <br />
            но его можно вернуть
        </>
    );
});

Title.displayName = 'Title';
